import { TrustLabelPeriod } from '../../../../../components-library/labels/TrustLabel';

export default {
  labels: {
    [TrustLabelPeriod.LESS_THAN_1_MONTH]: 'Plus de +100 clients ont déjà commandé en toute sécurité avec nous',
    [TrustLabelPeriod.ONE_MONTH_OR_MORE]: 'Plus de +1 000 clients ont déjà commandé en toute sécurité avec nous',
    [TrustLabelPeriod.SIX_MONTHS_OR_MORE]: 'Plus de +10 000 clients ont déjà commandé en toute sécurité avec nous',
  },
};
